import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Link } from 'react-router'

// import components
import Header from '../../shared/components/Header'

// Elements
import TabBar from '../../shared/elements/tabBar'
import TabItem from '../../shared/elements/tabItem'
import Button from '../../shared/elements/button'
import DateTime from '../../shared/elements/datetime'
import DropDown from '../../shared/elements/dropDown'
import Panel from '../../shared/elements/panel'
import Col from '../../shared/elements/col'
import Row from '../../shared/elements/row'
import TableContainer from '../../shared/elements/tableContainer'
import TableRow from '../../shared/elements/tableRow'

// import actions
import { getShopPunchTimeReport } from '../../actions/punchclock'
import { triggerPopup } from '../../actions/backdrop'
import { setPageTitle } from '../../actions/common'
// import styles
import './punchreport.scss'

// Utils
import { renderFullDate } from '../../utils/time'
import { translation } from '../../utils/helpers'
import { hasSubscriptionPermission } from '../../utils/auth'

// Modals
import PunchReportModal from '../../shared/modals/PunchReportModal'

class PunchReport extends Component {
  constructor (props) {
    super(props)
    this.state = {
      punchReport: [{
        Id: 0,
        DateRec: '',
        PunchIn: '',
        PunchOut: '',
        Away: false,
        AwayType: 0,
        StandardWorkHours: '',
        UnderOverTime: '',
        Pauses: 0,
        OverallPauseTime: '',
        Hours: 0,
        OverallHours: '',
        IsAdminRecord: false,
        ClosingDayId: 0,
        ClosingDayName: null
      }],
      From: null,
      To: null,
      UserId: null,
      punchmodal: {
        open: false
      }
    }
    this.renderHeaderTitle = this.renderHeaderTitle.bind(this)
    this.getReport = this.getReport.bind(this)
    this.renderInputArea = this.renderInputArea.bind(this)
    this.renderReportArea = this.renderReportArea.bind(this)
    this.renderReportHeader = this.renderReportHeader.bind(this)
    this.getReportFromState = this.getReportFromState.bind(this)
    this.calcTotals = this.calcTotals.bind(this)

    this.openMultipleEmployeesPopup = this.openMultipleEmployeesPopup.bind(this)
    this.closePunchModal = this.closePunchModal.bind(this)
    this.minutesToTimeFormat = this.minutesToTimeFormat.bind(this)
    this.parseTimeToMinutes = this.parseTimeToMinutes.bind(this)
  }

  componentDidMount () {
    if (this.props.location.query !== undefined) {
      let query = this.props.location.query
      let userId = query.UserId
      let fromDate = query.From
      let toDate = query.To

      if (userId === undefined || userId === null) userId !== 0
      if (fromDate === undefined) fromDate = null
      if (toDate === undefined) toDate = null

      this.setState({
        UserId: userId,
        From: fromDate !== null ? moment(fromDate) : null,
        To: toDate !== null ? moment(toDate) : null
      }, () => {
        this.getReportFromState()
      })
    }
    this.setBodyClass(false)
  }

  componentWillUnmount () {
    this.setBodyClass(true)
  }

  setBodyClass (out) {
    setTimeout(() => {
      if (out) {
        document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('puncreport__body', '')
      } else {
        document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className + ' puncreport__body'
      }
    }, 0)
  }

  getReport (userId, fromDateTime, toDateTime) {
    if (typeof userId === 'undefined') {
      userId = this.refs.employeeSelect.value
    }
    this.props.getShopPunchTimeReport(userId, fromDateTime, toDateTime).then((res) => {
      this.setState({
        punchReport: res.data
      })
    })
  }

  getReportFromState () {
    let userId = this.state.UserId
    if (userId === 0) return
    if (this.state.From === null) return null
    if (this.state.To === null) return null
    const formatDate = (moment) => {
      return moment.format('YYYY-MM-DD')
    }
    this.getReport(userId, formatDate(this.state.From), formatDate(this.state.To))
  }

  minutesToTimeFormat (minutes, minutesAsDecimal = false) {
    let negative = minutes < 0
    minutes = Math.abs(minutes)
    let h = (Math.floor(minutes / 60)).toFixed(0)
    let m = (minutes % 60).toFixed(0)
    if (minutesAsDecimal) {
      m = (parseInt(m) * (100 / 60)).toFixed(0)
      if (m.length === 1) m = '0' + m
      return h + ',' + m // need to add , or . depending on language.
    }
    if (m.length === 1) m = '0' + m
    return (negative ? '-' : '') + h + ':' + m
  }

  parseTimeToMinutes (time) {
    if (time === null || time === '') return 0
    let parts = time.split(':')
    let negative = parts[0].startsWith('-')
    let hours = Math.abs(parseInt(parts[0]))
    let minutes = parseInt(parts[1])
    let result = ((hours * 60) + minutes) * (negative ? -1 : 1)
    return result
  }

  calcTotals () {
    let breakTotal = 0
    let standardTimeTotal = 0
    let totalTimeTotal = 0
    // let totalTimeHourTotal = 0
    let underTimeTotal = 0
    // let underTimeHourTotal = 0
    let overTimeTotal = 0
    // let overTimeHourTotal = 0
    let VacationTotal = 0
    let SickTotal = 0
    let SickChildTotal = 0
    let AwayWithPayTotal = 0
    let AwayWithoutPayTotal = 0
    let VacationTotalDays = 0
    let SickTotalDays = 0
    let SickChildTotalDays = 0
    let AwayWithPayTotalDays = 0
    let AwayWithoutPayTotalDays = 0

    let report = this.state.punchReport
    let prevEntry = null
    if (report !== null && report.length > 0) {
      for (let i = 0; i < report.length; i++) {
        let entry = report[i]
        if (prevEntry === null || prevEntry.DateRec !== entry.DateRec) {
          let overUnder = this.parseTimeToMinutes(entry.UnderOverTime)
          if (overUnder > 0) {
            overTimeTotal += overUnder
          } else {
            underTimeTotal += overUnder
          }

          // overTimeTotal += entry.UnderOverTime > 0 ? entry.UnderOverTime : 0
          // underTimeTotal += entry.UnderOverTime < 0 ? entry.UnderOverTime : 0

          if (entry.OverallPauseTime !== '') {
            breakTotal += this.parseTimeToMinutes(entry.OverallPauseTime)
            // breakTotal += (parseInt(entry.OverallPauseTime.split(':', 2)[0]) * 60) + parseInt(entry.OverallPauseTime.split(':', 2)[1])
          }
          if (entry.StandardWorkHours !== '' && (!entry.Away || entry.AwayType === 4)) {
            standardTimeTotal += this.parseTimeToMinutes(entry.StandardWorkHours)
            // standardTimeTotal += (parseInt(entry.StandardWorkHours.split(':', 2)[0]) * 60) + parseInt(entry.StandardWorkHours.split(':', 2)[1])
          }
          if (entry.OverallHours !== '') {
            totalTimeTotal += this.parseTimeToMinutes(entry.OverallHours)
            // totalTimeTotal += (parseInt(entry.OverallHours.split(':', 2)[0]) * 60) + parseInt(entry.OverallHours.split(':', 2)[1])
          }

          if (entry.Away) {
            switch (entry.AwayType) {
              case 0:
                if (entry.StandardWorkHours !== '') {
                  VacationTotal += this.parseTimeToMinutes(entry.StandardWorkHours)  // Vacation
                  VacationTotalDays += 1
                }
                break
              case 1:
                if (entry.StandardWorkHours !== '') {
                  SickTotal += this.parseTimeToMinutes(entry.StandardWorkHours)  // Sick
                  SickTotalDays += 1
                }
                break
              case 2:
                if (entry.StandardWorkHours !== '') {
                  SickChildTotal += this.parseTimeToMinutes(entry.StandardWorkHours)  // Sick child
                  SickChildTotalDays += 1
                }
                break
              case 3:
                if (entry.StandardWorkHours !== '') {
                  AwayWithPayTotal += this.parseTimeToMinutes(entry.StandardWorkHours)  // Away with pay
                  AwayWithPayTotalDays += 1
                }
                break
              case 4:
                if (entry.StandardWorkHours !== '') {
                  AwayWithoutPayTotal += this.parseTimeToMinutes(entry.StandardWorkHours)  // Away without pay
                  AwayWithoutPayTotalDays += 1
                }
                break
            }
          }
        }
        prevEntry = entry
      }
    }

    return {
      BreakTotal: this.minutesToTimeFormat(breakTotal),
      StandardTimeTotal: this.minutesToTimeFormat(standardTimeTotal),
      TotalTimeTotal: this.minutesToTimeFormat(totalTimeTotal),
      TotalTimeHourTotal: this.minutesToTimeFormat(totalTimeTotal, true),
      UnderTimeTotal: this.minutesToTimeFormat(underTimeTotal),
      UnderTimeHourTotal: this.minutesToTimeFormat(underTimeTotal, true),
      OverTimeTotal: this.minutesToTimeFormat(overTimeTotal),
      OverTimeHourTotal: this.minutesToTimeFormat(overTimeTotal, true),

      VacationTotal: this.minutesToTimeFormat(VacationTotal),
      SickTotal: this.minutesToTimeFormat(SickTotal),
      SickChildTotal: this.minutesToTimeFormat(SickChildTotal),
      AwayWithPayTotal: this.minutesToTimeFormat(AwayWithPayTotal),
      AwayWithoutPayTotal: this.minutesToTimeFormat(AwayWithoutPayTotal),
      VacationTotalDays: VacationTotalDays,
      SickTotalDays: SickTotalDays,
      SickChildTotalDays: SickChildTotalDays,
      AwayWithPayTotalDays: AwayWithPayTotalDays,
      AwayWithoutPayTotalDays: AwayWithoutPayTotalDays
    }
  }

  renderHeaderTitle () {
    return translation('2159')
  }

  renderReportHeader (title) {
    return (
      <h2>{translation(title)}</h2>
    )
  }

  openMultipleEmployeesPopup (e) {
    e.preventDefault()
    this.props.triggerPopup(true)
    this.setState({
      punchmodal: {
        open: true
      }
    })
  }

  closePunchModal () {
    this.props.triggerPopup(false)
    this.setState({
      punchmodal: {
        open: false
      }
    })
  }

  renderInputArea () {
    const onDateChange = (name, e) => {
      this.setState({[name]: e})
    }

    const onEmployeeChange = (e) => {
      let userId = e.target.value
      if (this.state.UserId !== userId) {
        this.setState({UserId: userId})
      }
    }

    const onShowReportClick = (e) => {
      e.preventDefault()
      this.getReportFromState()
    }

    let canClickButtons = false
    if (this.state.From !== '' && this.state.To !== '' && this.state.From !== null && this.state.To !== null && this.state.UserId > 0) {
      canClickButtons = true
    }

    return (
      <Panel title=''>
        <DropDown name='employee' onChange={onEmployeeChange} value={this.state.UserId} ref='employeeSelect' labelText={translation('449')}>
          <option key={0} value={null}>{translation(1440)}</option>
          {this.props.employees.map((emp) => {
            if (emp.Active) {
              return (<option key={emp.UserId} value={emp.UserId}>{emp.Name}</option>)
            }
          })}
        </DropDown>
        <DateTime
          labelText={translation('434')}
          inputProps={{
            name: 'from',
            readOnly: true,
            placeholder: translation('1728')
          }}
          dateFormat='DD-MM-YYYY'
          timeFormat={false}
          closeOnSelect
          value={this.state.From}
          onChange={onDateChange.bind(this, 'From')} />
        <DateTime
          labelText={translation('187')}
          inputProps={{
            name: 'to',
            readOnly: true,
            placeholder: translation('1728')
          }}
          dateFormat='DD-MM-YYYY'
          timeFormat={false}
          closeOnSelect
          value={this.state.To}
          onChange={onDateChange.bind(this, 'To')} />
        <Button disabled={!canClickButtons} onClick={onShowReportClick} labelText={translation('380')} />
        <Button style='link' disabled={!canClickButtons} onClick={this.openMultipleEmployeesPopup} labelText={translation('2240')} />
      </Panel>
    )
  }

  renderReportArea () {
    let entries = this.state.punchReport
    const renderEntries = () => {
      const BLANK = <span>&nbsp;</span>
      let prevEntry = null
      const renderTotals = () => {
        let totals = this.calcTotals()
        return (
          <div className='totals'>
            <TableRow>
              <div>{translation(472)}</div>
              <div>{BLANK}</div>
              <div>{BLANK}</div>
              <div>{BLANK}</div>
              {/*  <div className='time'>{totals.BreakTotal}</div> */}
              <div>{totals.StandardTimeTotal}</div>
              <div>
                <div>{totals.TotalTimeTotal}</div>
                <div>({totals.TotalTimeHourTotal} {translation('989')})</div>
              </div>
              <div>
                <div>{totals.UnderTimeTotal}</div>
                <div>({totals.UnderTimeHourTotal} {translation('989')})</div>
              </div>
              <div>
                <div>{totals.OverTimeTotal}</div>
                <div>({totals.OverTimeHourTotal} {translation('989')})</div>
              </div>
            </TableRow>
            {totals.VacationTotal !== '0:00' && (
              <TableRow>
                <div>{translation('500')}</div>
                <div>{totals.VacationTotal + ' (' + totals.VacationTotalDays + ' ' + translation('503') + ')'}</div>
              </TableRow>
            )}
            {totals.SickTotal !== '0:00' && (
              <TableRow>
                <div>{translation('508')}</div>
                <div>{totals.SickTotal + ' (' + totals.SickTotalDays + ' ' + translation('503') + ')'}</div>
              </TableRow>
            )}
            {totals.SickChildTotal !== '0:00' && (
              <TableRow>
                <div>{translation('502')}</div>
                <div>{totals.SickChildTotal + ' (' + totals.SickChildTotalDays + ' ' + translation('503') + ')'}</div>
              </TableRow>
            )}
            {totals.AwayWithPayTotal !== '0:00' && (
              <TableRow>
                <div>{translation('1436')}</div>
                <div>{totals.AwayWithPayTotal + ' (' + totals.AwayWithPayTotalDays + ' ' + translation('503') + ')'}</div>
              </TableRow>
            )}
            {totals.AwayWithoutPayTotal !== '0:00' && (
              <TableRow>
                <div>{translation('1435')}</div>
                <div>{totals.AwayWithoutPayTotal + ' (' + totals.AwayWithoutPayTotalDays + ' ' + translation('503') + ')'}</div>
              </TableRow>
            )}
          </div>
        )
      }
      const renderEntry = (entry, key) => {
        console.log('entry.IsAdminRecord ', entry.IsAdminRecord, entry)
        // console.log('entry', entry)
        let date = entry.DateRec
        let punchIn = entry.PunchIn
        let punchOut = entry.PunchOut
        // let pauses = entry.Pauses
        let pausesText = entry.PausesText
        let totalPause = entry.OverallPauseTime
        let standardHours = entry.StandardWorkHours
        let totalHours = entry.OverallHours
        let overUnderMinutes = this.parseTimeToMinutes(entry.UnderOverTime)
        let overTime = overUnderMinutes > 0 ? overUnderMinutes : 0
        let underTime = overUnderMinutes < 0 ? overUnderMinutes : 0
        let closingDayId = entry.ClosingDayId
        let closingDayName = entry.ClosingDayName !== null ? entry.ClosingDayName : translation('500')   // Holiday
        let awayType = entry.AwayType
        let awayTypeName = null
        let isAdminRec = entry.IsAdminRecord

        if (entry.Away) {
          switch (awayType) {
            case 0:
              awayTypeName = translation('500')     // Vacation
              break
            case 1:
              awayTypeName = translation('508')     // Sick
              break
            case 2:
              awayTypeName = translation('502')     // Sick child
              break
            case 3:
              awayTypeName = translation('1436')    // Away with pay
              break
            case 4:
              awayTypeName = translation('1435')   // Away without pay
              break
          }
        }

        // If current entry date is same as previous entry date, don't write out date again.
        if (prevEntry !== null && prevEntry.DateRec === entry.DateRec) date = BLANK

        // Replace blank fields.
        if (punchIn === '') punchIn = '-'
        if (punchOut === '') punchOut = '-'
        if (standardHours === '' || standardHours === '00:00') standardHours = BLANK
        if (totalHours === '' || totalHours === '00:00') totalHours = BLANK

        if (punchIn === '-' && punchOut === '-' && entry.Away && awayType !== 4) standardHours = BLANK

        overTime = overTime === 0 ? BLANK : this.minutesToTimeFormat(overTime)
        underTime = underTime === 0 ? BLANK : this.minutesToTimeFormat(underTime)
        // if (overTime === 0) overTime = BLANK
        // if (underTime === 0) underTime = BLANK

        if (totalPause === '00:00') totalPause = ''

        // Break minutes
        if (pausesText === null || pausesText === '') {
          pausesText = '-'
        }

        if (totalPause === '') totalPause = BLANK

        if (prevEntry !== null && prevEntry.DateRec === entry.DateRec) {
          // pauses = BLANK
          pausesText = BLANK
          totalPause = BLANK
          standardHours = BLANK
          totalHours = BLANK
          overTime = BLANK
          underTime = BLANK
        }

        let specialDay = null
        if (awayType !== null) specialDay = awayTypeName
        if (closingDayId !== 0) specialDay = closingDayName
        let extraClass = specialDay === null ? '' : 'specialday'

        prevEntry = entry
        // console.log('key', key, 'entry', entry)
        let punchClass = isAdminRec ? 'isModified' : ''
        return (
          <TableRow key={key + '_' + entry.id} className={punchClass}>
            {(specialDay !== null) && (
            <div className='date'>
              <div>{date}</div>
              <div className={extraClass}>({specialDay})</div>
            </div>
            ) || (
            <div className='date'>
              <div>{date}</div>
            </div>
            )}
            <div className={'time_small '}>{punchIn}</div>
            <div className={'time_small '}>{punchOut}</div>
            { /* <div className='pause'>{pausesText}</div> */ }
            <div className='time'>{totalPause}</div>
            <div className='time'>{standardHours}</div>
            <div className='time'>{totalHours}</div>
            <div className='time_small'>{underTime}</div>
            <div className='time_small'>{overTime}</div>
          </TableRow>
        )
      }
      return (
        <TableContainer>
          <TableRow header>
            <div className='date'>{translation('388')}</div>
            <div className='time_small'>{translation('443')}</div>
            <div className='time_small'>{translation('1899')}</div>
            { /* <div className='pause'>{translation('468')}</div> */ }
            <div className='time'>{translation('595')}</div>
            <div className='time'>{translation('469')}</div>
            <div className='time'>{translation('470')}</div>
            <div className='time_small'>{translation('2158')}</div>
            <div className='time_small'>{translation('455')}</div>
          </TableRow>
          {entries.map(renderEntry)}
          {renderTotals()}
        </TableContainer>
      )
    }

    return (
      this.state.punchReport.length > 0 && renderEntries()
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    const formatDate = (moment) => {
      return moment.format('YYYY-MM-DD')
    }
    let fromDate = this.state.From !== null && this.state.From !== '' ? formatDate(this.state.From) : null
    let toDate = this.state.To !== null && this.state.To !== '' ? formatDate(this.state.To) : null

    let editLinkParams = ''
    if (this.state.UserId !== 0) {
      editLinkParams += (editLinkParams === '' ? '?' : '&')
      editLinkParams += 'UserId=' + this.state.UserId
    }
    if (this.state.From !== null && this.state.From !== '') {
      editLinkParams += (editLinkParams === '' ? '?' : '&')
      editLinkParams += 'From=' + fromDate
    }

    if (this.state.To !== null) {
      editLinkParams += (editLinkParams === '' ? '?' : '&')
      editLinkParams += 'To=' + toDate
    }
    return (
      <div className='punchreport__screen'>
        <Header router={this.props.router} >
          <TabBar>
            <TabItem><Link to={'/punchreport' + editLinkParams} className='active'>{translation('2159')}</Link></TabItem>
            <TabItem><Link to={'/punchedit' + editLinkParams}>{translation('2206')}</Link></TabItem>
            <TabItem><Link to={'/absencereport'}>{translation('1128')}</Link></TabItem>
          </TabBar>
        </Header>
        <h1 className='title__header'>{translation('2231')}</h1>
        <Row>
          <Col>
            {this.renderInputArea()}
          </Col>
        </Row>
        <Row>
          {this.renderReportHeader('459')}
          {this.renderReportArea()}
          {this.state.punchmodal.open && (
            <PunchReportModal
              show={this.state.punchmodal.open}
              From={this.state.From}
              To={this.state.To}
              onClose={this.closePunchModal} />
          )}
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees
  }
}

export default connect(mapStateToProps, {
  renderFullDate,
  getShopPunchTimeReport,
  triggerPopup,
  setPageTitle
})(PunchReport)



// WEBPACK FOOTER //
// ./src/app/pages/PunchReport/index.js